import { Component, OnInit,ElementRef, Renderer2, Inject, AfterViewInit, ViewChild } from '@angular/core';
import { Router } from "@angular/router"
import { FormGroup, FormBuilder, Validators, FormControl } from "@angular/forms"; 
import { ViewEncapsulation } from '@angular/core'; 
import { DOCUMENT } from '@angular/common';
import { AuthenticationService } from '@services/security';
import { LoaderService } from '@modules/loader';
import { SendCodeModel } from '@shared/security/send-code.model';
import { VerifyCodeModel } from '@shared/security/verify-code.model';
import { AppConsts } from '@shared/app-consts';
import { CircleTimerComponent } from '@flxng/circle-timer';

@Component({
  selector: 'app-twofactor-verifycode',
  templateUrl: './verify-code.component.html',
  styleUrls: ['./verify-code.component.scss'] 
})
export class TwoFactorVerifyCodeComponent implements OnInit, AfterViewInit {
    @ViewChild('timer', { static: false }) timer: CircleTimerComponent;
    startDate = Date.now();
    duration = 60 * 1000; // 1 minute
    isError:boolean;
    submitted:boolean;
    IsTwoFactorRememberClient:boolean;
    receivedToken:string;
    verifyCodeForm:FormGroup;
    email:string;
    get f() { return this.verifyCodeForm.controls; }
    
    constructor(private service: AuthenticationService,
        private router: Router,
        public formBuilder: FormBuilder, 
        private loaderService: LoaderService, private renderer: Renderer2,
        @Inject(DOCUMENT) private _document) {
        }

        
  ngOnInit() {
      this.buildForm(); 
      this.email= sessionStorage.getItem(AppConsts.DecisielCurrentEmail);      
      if(!this.email || this.email == null || this.email.trim() === '')
       this.router.navigate(['login']);
  } 

 buildForm(){
     this.loaderService.hideLoader();
    this.verifyCodeForm = this.formBuilder.group({ 
        receivedToken: ["", Validators.compose([
            Validators.required,
            this.checkFilled
          ])]
    }); 
  }

  ngAfterViewInit(): void {
    this.timer.start(this.startDate);
  }

  verifyCode($event){
    this.submitted=true;
   //  if(this.verifyCodeForm.invalid)   return;
  let model = new VerifyCodeModel();
    model.Code = $event;
  model.Email = this.email;
  model.Provider = sessionStorage.getItem(AppConsts.DecisielCurrentTwoFactorProvider);
  model.RememberClient = true;
  const rememberMe = sessionStorage.getItem(AppConsts.REMEMBER_ME);
  this.loaderService.showLoader();
  this.service.verifyCodeTwofactor(model).subscribe((response:any)=>{
    this.loaderService.hideLoader();
   if(response && response != null){
    this.service.signIn(response,model.Email,rememberMe);
    localStorage.setItem(AppConsts.IsTwoFactorRememberClient,"true");
    this.router.navigate(['']); 
   }
   else
   this.isError = true;
  },(error)=>{
     this.loaderService.hideLoader();     
  }); 
 }

 backToSendCode(){
    this.router.navigate(['login/send-code']); 
 }

 checkFilled(champ: FormControl) {
    
    if (champ.value) {
      let text = champ.value.trim();
      if (text.length ==0) 
      {
        return {
          checkFilled: {
           valid: false
        }
       };
      }
      else
       return null;     
    }
    else
    return {
      checkFilled: {
       valid: false
    }    
  }

  }
  reSendCode() {
    this.isError = false;
    let model = new SendCodeModel();
    model.SelectedProvider = sessionStorage.getItem(AppConsts.DecisielCurrentTwoFactorProvider);
    model.Email = sessionStorage.getItem(AppConsts.DecisielCurrentEmail);
    this.loaderService.showLoader();
    this.service.sendCodeTwofactor(model).subscribe(
      (response: any) => {
        this.loaderService.hideLoader();
        if (response) {
          this.timer.init();
          this.timer.start();
        }
      },
      (error) => {
        this.loaderService.hideLoader();
      }
    );
  }
}
